var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 713.563,
    height: 377.514,
    viewBox: "0 0 713.563 377.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-239.648 -535.486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1096.563,424.138a188.165,188.165,0,0,1-356.782,83.486A188.154,188.154,0,0,1,383,424.138C383,320.235,467.235,236,571.138,236A188.148,188.148,0,0,1,739.782,340.652,188.148,188.148,0,0,1,908.425,236C1012.328,236,1096.563,320.235,1096.563,424.138Z",
    transform: "translate(-143.352 299.486)",
    fill: "#29abe2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.3,679.236c-33.364,52.586-90.857,87.49-157.739,87.49A188.148,188.148,0,0,1,759.922,662.074a188.191,188.191,0,0,1-325.7,20.12C516.586,655.019,634.519,638,765.492,638,891.656,638,1004.477,653.794,1086.3,679.236Z",
    transform: "translate(-162.873 146.274)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432.737 664.831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M695,576.2l30.951-45.384,24.431-8.784,15.154-23.471L789,480.968l14.661,13.2,33.721-20.526L861.544,445l33.013,28.638,17.593,30.789,24.925-7.331L962,513.224l8.8,20.526,24.925,11.729,13.667,30.723S896.61,579.876,859,579.915C817.991,579.957,695,576.2,695,576.2Z",
    transform: "translate(-695 -445)",
    fill: "#303644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.023,520.629l11.334,8.224L805.3,564.04l-44.442,3.394,19.894-11.919,14.722-24.16Z",
    transform: "translate(-720.099 -473.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.251,510.665l-29.323,52.781L898.3,548.785l10.263-17.594-26.391-1.466L911.5,503.334v-38.12l-13.2,21.992Z",
    transform: "translate(-745.662 -452.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.849,529.179l7.331,16.128H955.857Z",
    transform: "translate(-794.419 -477.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.551,570.347l-2.932-20.526,17.594-8.8,5.865,21.992-7.331,11.729",
    transform: "translate(-830.535 -481.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.593,600.25l19.06,7.331-19.06,13.2H1071.94Z",
    transform: "translate(-838.661 -504.17)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.10efd08523243e5a17c4efb03b993436.svg";
export { ForwardRef as ReactComponent };